import React from "react";
import { func } from "prop-types";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Form,
  FormGroup,
  Label,
  Row
} from "reactstrap";
import _ from 'lodash';

// Strings
import { getMessage } from "CONFIG/i18n";
import modalScrollBar from "../ModalScrollBar/ModalScrollBar";

import "./AppEmulation.less";
import "COMPONENTS/App/App.less";

class AppEmulationDeviceListModal extends React.Component {
  static propTypes = {
    handleSubmitClick: func,
    toggle: func
  };
  constructor(props) {
    super(props);
    this.error = {
      OS_SELECTION_ERROR_CODE: "OS_SELECTION_ERROR",
      DEIVCE_SELECTION_ERROR_CODE: "DEVICE_SELECTION_ERROR",
      OS_VERSION_SELECTION_ERROR_CODE: "OS_VERSION_SELECTION_ERROR",
      APPLICATION_SELECTION_ERROR_CODE: "APPLICATION_SELECTION_ERROR"
    };
    this.state = {
      selectDeviceOSVersionList: [],
      selectedOS: "",
      selectedOSName: "",
      selectedOSVersion: "",
      selectedDeviceName: "",
      selectedApplication: "",
      errorMessage: ""
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.show !== this.props.show && this.props.show) {
      this.preselectValues();
    }
  }

  componentWillUnmount() {
    this.disableStartBtn(false);
  }

  areMultipleOSPresent = () => {
    return this.props.deviceInfo.osInfoArray.length > 1;
  }

  handleCancelClick = () => {
    this.props.toggle();
    this.errorCallBack(false);
  };

  handleSubmitClick = () => {
    if(!this.props.checkParticipantsAvailable()) {
      this.props.toggle();
      this.disableStartBtn(false);
      return;
    }
    if (!this.validateSelectedData()) {
      this.disableStartBtn(false);
      return;
    }

    this.disableStartBtn(true);

    let request_data = {
      os: this.state.selectedOSName.toLowerCase(),
      device: this.state.selectedDeviceName.toLowerCase(),
      version: this.state.selectedOSVersion,
      application: this.state.selectedApplication
    };
    this.props.handleSubmitClick(request_data, this.errorCallBack);
  };

  resetSelectFromState = () => {
    this.setState({
      selectedOS: "",
      selectedDeviceName: "",
      selectedOSVersion: "",
      selectDeviceOSVersionList: [],
      selectedApplication: "",
      errorMessage: "",
    });
    this.preselectValues();
  };

  errorCallBack = errorCode => {
    if (!errorCode) {
      this.resetSelectFromState();
      this.props.toggle();
    } else {
      this.setState({ errorMessage: errorCode });
    }
    let startBtn = document.getElementById("startAppEmulationBtn");
    if(startBtn) startBtn.disabled = false
  };

  validateSelectedData = () => {
    if (this.state.selectedOS) {
      if (this.state.selectedDeviceName && this.state.selectedDeviceName !== getMessage("SELECTION")) {

        if (this.state.selectedOSVersion && this.state.selectedOSVersion !== getMessage("SELECTION")) {
          
          if(this.state.selectedApplication && this.state.selectedApplication !== getMessage("SELECTION")){
            
            this.setState({ errorMessage: "" });
            return true;
          
          }
          this.setState({
            errorMessage:this.error.APPLICATION_SELECTION_ERROR_CODE
          });
          return false;

        }
        this.setState({
          errorMessage: this.error.OS_VERSION_SELECTION_ERROR_CODE
        });
        return false;
      }
      this.setState({ errorMessage: this.error.DEIVCE_SELECTION_ERROR_CODE });
      return false;
    }
    this.setState({ errorMessage: this.error.OS_SELECTION_ERROR_CODE });
  };

  handleOSOnChange = event => {

    let selectedOSName = this.getOperatingSystem(event.target.value);
    let deviceInfoArray = this.props.deviceInfo.deviceInfoArray[selectedOSName];

    this.setState({
      selectedOS: event.target.value,
      selectedOSName: selectedOSName,
      selectedDeviceName: deviceInfoArray && deviceInfoArray.length === 1 ? deviceInfoArray[0].name : "",
      selectedOSVersion: "",
      selectDeviceOSVersionList: [],
      selectedApplication: "",
      errorMessage: ""
    }, this.setDefaultValues);
  };

  handleDeviceOnChange = event => {
    this.setState({
      selectedDeviceName: event.target.value,
      selectedOSVersion: "",
      selectDeviceOSVersionList: [],
      errorMessage: ""
    },
    this.getVersionOption);
  };

  handleOSVersionChange = event => {
    this.setState(
      {
        selectedOSVersion: event.target.value,
        errorMessage: ""
      }
    );
  };

  handleApplicationChange = (event) => {
    this.setState({
      selectedApplication: event.target.value,
      errorMessage :""
    });
  };

  /**
   * If application list contains only one application then select first application
   */
  selectFirstApplication = () => {
    let applications= this.getApplications();
    if(applications.length === 1) {
      this.setState({
        selectedApplication: applications[0].id
      })
    }
  }

  getApplications = () => {
    return (this.state.selectedOS ? _.filter(this.props.deviceInfo.appEmulationApplications, (appEmulationApplicationObject) => {
      return appEmulationApplicationObject.osId == this.state.selectedOS
    }) : []);
  }

  getVersionOption = () => {
    if (this.state.selectedOS) {

      let deviceInfoObject = _.find(this.props.deviceInfo.deviceInfoArray[this.state.selectedOSName], (deviceInfoObject) => { 
        return deviceInfoObject.name === this.state.selectedDeviceName
      });

      if(deviceInfoObject) {
        this.setState({
          selectDeviceOSVersionList: deviceInfoObject.os_versions,
          selectedOSVersion: deviceInfoObject.os_versions.length === 1 ? deviceInfoObject.os_versions[0] : ""
        });
      }
    }
  };

  getOperatingSystem = (osId) => {
    let osInfoObject = _.find(this.props.deviceInfo.osInfoArray, (osInfo) => { return  (osInfo.id == osId)  });
    return osInfoObject ? osInfoObject.name: null;
  }

  preselectValues = () => {
    if(this.props.deviceInfo.osInfoArray.length >= 1) {

      let selectedOSName = this.getOperatingSystem(this.props.deviceInfo.osInfoArray[0].id);
      let deviceInfoArray = this.props.deviceInfo.deviceInfoArray[selectedOSName];

      this.setState({
        selectedOS: this.props.deviceInfo.osInfoArray[0].id,
        selectedOSName: selectedOSName,
        selectedDeviceName: deviceInfoArray && deviceInfoArray.length === 1 ?  deviceInfoArray[0].name : ""
      }, this.setDefaultValues);
    }
  }

  disableStartBtn = (value) => {
    let addBtn = document.getElementById("startAppEmulationBtn");
    if(addBtn){
      addBtn.disabled = value;
      if(value)
        addBtn.classList.add("pointerEventsNone");
      else
        addBtn.classList.remove("pointerEventsNone");
    }
  }

  getDeviceName = (deviceInfoObject) => {
    return this.props.selectedLangauge === "jap" ?
      deviceInfoObject.display_name_JAP :
      deviceInfoObject.display_name_EN
  }

  setDefaultValues = () => {
    let deviceInfoArray = this.props.deviceInfo.deviceInfoArray[this.state.selectedOSName];

    // If only one device is present, then display OS version 
    if(deviceInfoArray && deviceInfoArray.length === 1){
      this.getVersionOption();
    }

    this.selectFirstApplication();
  }

  renderButtons = () => {
    return (
      <div>
        <Button
          id="startAppEmulationBtn"
          onClick={() => {  
            this.disableStartBtn(true);
            this.handleSubmitClick();
          }
          }
          className="btn-accept customBtn deviceModalButton margin-right-5"
        >
          {getMessage("START")}
        </Button>
        {" "}
        <Button
          className="btn-decline deviceModalButton"
          onClick={this.handleCancelClick}
        >
          {getMessage("CANCEL")}
        </Button>
      </div>
    );
  };

  renderDevices = () => {
    let deviceInfoArray = this.props.deviceInfo.deviceInfoArray[this.state.selectedOSName];

    return (
      <FormGroup>
        <Label className="label">{getMessage("DEVICE")}</Label>
        {deviceInfoArray && deviceInfoArray.length === 1 ? 
          <Label className="flex5">
            {this.getDeviceName(deviceInfoArray[0])}
          </Label> :
          <Input
            type="select"
            id="device"
            className="inputFormControl"
            onChange={this.handleDeviceOnChange}
            key={this.state.selectedOS}
          >
            <option>{getMessage("SELECTION")}</option>

            {deviceInfoArray && deviceInfoArray.map(
              (deviceInfoObject, index) => ( 
                <option key={index} value={deviceInfoObject.name}>
                  {this.getDeviceName(deviceInfoObject)}
                </option>
              )
            )}
          </Input>}
      </FormGroup>
    )
  }

  renderOSVersions = () => {

    return (
      <FormGroup>
        <Label className="label">{getMessage("OS_VERSION")}</Label>
        {this.state.selectDeviceOSVersionList.length === 1 ? 
          <Label className="flex5">{this.state.selectDeviceOSVersionList[0]}</Label> : 
          <Input
            type="select"
            name="osVersion"
            className="inputFormControl"
            id="osVersion"
            onChange={this.handleOSVersionChange}
          >
            <option>{getMessage("SELECTION")}</option>
            {_.map(this.state.selectDeviceOSVersionList, (version, index) => (
              <option key={index} value={version}>
                {version} 
              </option>
            ))}
          </Input>}
      </FormGroup>
    )
  }

  renderApplications = () => {

    let applications = this.getApplications();

    if(applications) {

      return (
        <FormGroup>
          <Label className="label">{getMessage("APPLICATION")}</Label>
          {applications.length === 1 ? 
            <Label className="flex5">{applications[0].name}</Label> :
            <Input
              type="select"
              name="application"
              className="inputFormControl"
              id="application"
              onChange={this.handleApplicationChange}
            >
              <option>{getMessage("SELECTION")}</option>
              {_.map(applications,(appEmulationApplicationObject) => {
                return <option key={appEmulationApplicationObject.id} value={appEmulationApplicationObject.id}>
                  {appEmulationApplicationObject.name}
                </option>
              })}
            </Input>}
        </FormGroup>
      );
    }
  }

  render() {
    const android = "Android";

    return (
      <div className="selectDevice">
        <Modal
          isOpen={this.props.show}
          backdrop="static"
          className="selectDevice"
          toggle={this.props.handleCancelClick}
        >
          <ModalHeader className="popupHeader">
            {/* {getMessage("APP_EMULATION_DEVICE_SELECTION")} */}
            {getMessage("APP_EMULATION")}
          </ModalHeader>
          <ModalBody>
            {Object.keys(this.props.deviceInfo.osInfoArray).length !== 0 ? <>
              <Form>
                <FormGroup>
                  <Label className="label">{getMessage("OS")}</Label>
                  <div style={{ flex: "4 1 5%" }}>
                    <Row>
                      {this.props.deviceInfo.osInfoArray.map((osObject, index) => (
                        <FormGroup check key={osObject.name}>
                          <Label key={index} check className={this.areMultipleOSPresent() ? "mr-5" : "mr-5 appEmulationOs"}>
                            <Input
                              type={this.areMultipleOSPresent() ? "radio" : null}
                              onChange={this.handleOSOnChange}
                              value={osObject.id}
                              name="radioButtons"
                              id={osObject.id}
                              key={index}
                              checked={osObject.id == this.state.selectedOS}
                              hidden={!this.areMultipleOSPresent()}
                            />
                            {osObject.name === android ? getMessage("ANDROID") : getMessage("IOS")}
                          </Label>
                        </FormGroup>
                      ))}
                    </Row>
                  </div>
                </FormGroup>
                {this.renderDevices()}

                {this.renderOSVersions()}

                {this.renderApplications()}
              </Form>
              <span className=" errors " style={{display: this.state.errorMessage ? "block" : "none"}}>
                {getMessage(this.state.errorMessage)}
              </span>
            </>
              : <div className="inProgressDiv"> {getMessage("FEATURE_IN_PROGRESS")} </div>
            }
          </ModalBody>
          <ModalFooter className="permissionButtons">
            {this.renderButtons()}
          </ModalFooter>
        </Modal>
      </div>             
    
    );
  }
}

export default modalScrollBar(AppEmulationDeviceListModal);
